import { useMutation } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import { z } from 'zod/v4';

import {
  type ApiError,
  type ApiResponse,
  addActionNameToMutationResult,
  useAxiosInstance,
} from './utils';

export const AcceptRecovrTosSchema = z.object({});

export type AcceptRecovrTosVariables = z.infer<typeof AcceptRecovrTosSchema>;

async function acceptRecovrTosMutation(
  axiosInstance: Promise<AxiosInstance>,
  vars: AcceptRecovrTosVariables,
) {
  const instance = await axiosInstance;

  const data = instance.post('accept_tos', AcceptRecovrTosSchema.parse(vars));
  return data;
}

export function useAcceptRecovrTos() {
  const axiosInstance = useAxiosInstance();

  const mutation = useMutation<ApiResponse, ApiError, AcceptRecovrTosVariables>({
    mutationFn: (vars: AcceptRecovrTosVariables) => acceptRecovrTosMutation(axiosInstance, vars),
  });

  return addActionNameToMutationResult<
    ApiResponse,
    ApiError,
    AcceptRecovrTosVariables,
    'acceptRecovrTos'
  >('acceptRecovrTos', mutation);
}
